import { lazy, Suspense } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import { I18nProvider } from "@/i18n/context";
import Index from "./pages/Index.tsx";
import ScrollToTop from "./components/ScrollToTop";




// Code-split heavier secondary routes to reduce initial JS payload
const Catalogue = lazy(() => import("./pages/Catalogue.tsx"));
const ScenographieVegetale = lazy(() => import("./pages/ScenographieVegetale.tsx"));
const LocationPlantes = lazy(() => import("./pages/LocationPlantes.tsx"));
const LocationPlantesCoteAzur = lazy(() => import("./pages/LocationPlantesCoteAzur.tsx"));
const LocationPlantesBureauxCannes = lazy(() => import("./pages/LocationPlantesBureauxCannes.tsx"));
const LocationPlantesBureauxCoteAzur = lazy(() => import("./pages/LocationPlantesBureauxCoteAzur.tsx"));
const LocationPlantesHotelsCoteAzur = lazy(() => import("./pages/LocationPlantesHotelsCoteAzur.tsx"));
const LocationPlantesRestaurantsCoteAzur = lazy(() => import("./pages/LocationPlantesRestaurantsCoteAzur.tsx"));
const LocationPlantesBureaux = lazy(() => import("./pages/LocationPlantesBureaux.tsx"));
const LocationPlantesHotels = lazy(() => import("./pages/LocationPlantesHotels.tsx"));
const LocationPlantesRestaurants = lazy(() => import("./pages/LocationPlantesRestaurants.tsx"));
const LocationPlantesMariage = lazy(() => import("./pages/LocationPlantesMariage.tsx"));
const VegetalisationSurMesure = lazy(() => import("./pages/VegetalisationSurMesure.tsx"));
const TableauxVegetaux = lazy(() => import("./pages/TableauxVegetaux.tsx"));
const MursVegetaux = lazy(() => import("./pages/MursVegetaux.tsx"));
const MassifsVegetalises = lazy(() => import("./pages/MassifsVegetalises.tsx"));
const DecorationVegetaleMobilier = lazy(() => import("./pages/DecorationVegetaleMobilier.tsx"));
const ProjectDetail = lazy(() => import("./pages/ProjectDetail.tsx"));
const NotFound = lazy(() => import("./pages/NotFound.tsx"));
const Unsubscribe = lazy(() => import("./pages/Unsubscribe.tsx"));
const Contact = lazy(() => import("./pages/Contact.tsx"));
const APropos = lazy(() => import("./pages/APropos.tsx"));
const MentionsLegales = lazy(() => import("./pages/MentionsLegales.tsx"));
const PolitiqueConfidentialite = lazy(() => import("./pages/PolitiqueConfidentialite.tsx"));
const CookiesPage = lazy(() => import("./pages/Cookies.tsx"));
const Realisations = lazy(() => import("./pages/Realisations.tsx"));

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <I18nProvider>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <ScrollToTop />
          <Suspense fallback={null}>
            <Routes>
              <Route path="/" element={<Index />} />
              <Route path="/catalogue" element={<Catalogue />} />
              <Route path="/scenographie-vegetale" element={<ScenographieVegetale />} />
              <Route path="/location-de-plantes" element={<LocationPlantes />} />
              <Route path="/location-plantes-cote-azur" element={<LocationPlantesCoteAzur />} />
              <Route path="/location-plantes-bureaux-cannes" element={<LocationPlantesBureauxCannes />} />
              <Route path="/location-plantes-bureaux-cote-azur" element={<LocationPlantesBureauxCoteAzur />} />
              <Route path="/location-plantes-hotels-cote-azur" element={<LocationPlantesHotelsCoteAzur />} />
              <Route path="/location-plantes-restaurants-cote-azur" element={<LocationPlantesRestaurantsCoteAzur />} />
              <Route path="/location-plantes-bureaux" element={<LocationPlantesBureaux />} />
              <Route path="/location-plantes-hotels" element={<LocationPlantesHotels />} />
              <Route path="/location-plantes-restaurants" element={<LocationPlantesRestaurants />} />
              <Route path="/location-plantes-mariage" element={<LocationPlantesMariage />} />
              <Route path="/vegetalisation-sur-mesure" element={<VegetalisationSurMesure />} />
              <Route path="/catalogue/tableaux-vegetaux" element={<TableauxVegetaux />} />
              <Route path="/catalogue/murs-vegetaux" element={<MursVegetaux />} />
              <Route path="/catalogue/massifs-vegetalises" element={<MassifsVegetalises />} />
              <Route path="/catalogue/decoration-vegetale-mobilier" element={<DecorationVegetaleMobilier />} />
              <Route path="/realisations" element={<Realisations />} />
              <Route path="/projets/:slug" element={<ProjectDetail />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/a-propos" element={<APropos />} />
              <Route path="/mentions-legales" element={<MentionsLegales />} />
              <Route path="/politique-confidentialite" element={<PolitiqueConfidentialite />} />
              <Route path="/cookies" element={<CookiesPage />} />
              <Route path="/unsubscribe" element={<Unsubscribe />} />
              {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>


        </BrowserRouter>
      </TooltipProvider>
    </I18nProvider>
  </QueryClientProvider>
);

export default App;
